/**
 * Entity identity from GET /events/:interest headers, plus results-page routing.
 * Empty event arrays are not a search failure when the backend resolved an entity.
 */

function headerValue(headers, name) {
  if (!headers) return undefined;
  const lower = name.toLowerCase();
  if (typeof headers.get === 'function') {
    const fromGet = headers.get(name) ?? headers.get(lower);
    if (fromGet != null && fromGet !== '') return fromGet;
  }
  if (headers[name] != null && headers[name] !== '') return headers[name];
  if (headers[lower] != null && headers[lower] !== '') return headers[lower];
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === lower) return headers[key];
  }
  return undefined;
}

export function decodeHeaderName(value) {
  if (value == null || value === '') return null;
  const raw = String(value);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function parseSearchEntityHeaders(headers) {
  return {
    entityId: headerValue(headers, 'x-livenow-entity-id') || null,
    entityName: decodeHeaderName(headerValue(headers, 'x-livenow-entity-name')),
    hubFamily: headerValue(headers, 'x-livenow-hub-family') || null,
  };
}

export function resolveSearchEntity({ entityId, entityName, events, query }) {
  const firstEvent = Array.isArray(events) && events.length > 0 ? events[0] : null;
  return {
    entityId: entityId || firstEvent?.entityId || null,
    entityName: entityName || firstEvent?.entityName || query || null,
  };
}

export function shouldTreatAsNoResults({ entityId, eventCount }) {
  return !entityId && !(eventCount > 0);
}

export function shouldShowResultsGallery({
  searchError,
  keepQuotaResults = false,
  entityId,
  resultsLength = 0,
}) {
  if (keepQuotaResults) return true;
  if (searchError) return false;
  return resultsLength > 0 || Boolean(entityId);
}
